import React, { Component } from 'react';

//import VeranstaltungList from "./veranstaltung/VeranstaltungList";

import {
  Route,
  withRouter,
  Switch
} from 'react-router-dom';

import Header from "./Header";
import Welcome from "./components/Welcome";

import './App.css';
import WinterImage from "./images/cover_winter.jpg";
import SummerImage from "./images/cover2.jpg";
import Veranstaltungen from './components/Veranstaltungen';
import Veranstaltung from './components/Veranstaltung';
import AnmeldungTrainer from './components/AnmeldungTrainer';
import AnmeldungSportler from './components/AnmeldungSportler';
import AnmeldungErfolgreich from './components/AnmeldungErfolgreich';
import Impressum from "./components/Impressum";


class App extends Component {  

  render() {
    const currentMonth = new Date().getMonth();
    const isSummer = currentMonth > 2 && currentMonth < 10;
    const CoverImage = isSummer ? SummerImage : WinterImage;

    return (
      <div>
        <Header />

        <div className="container jh-content-container">
          <Switch>
            <Route exact path="/" component={Welcome} />
            
            <Route path="/veranstaltungen/:id" component={Veranstaltung} />
            <Route path="/veranstaltungen" component={Veranstaltungen} />

            <Route path="/anmeldung/:id/sportler" component={AnmeldungSportler} />
            <Route path="/anmeldung/:id/trainer" component={AnmeldungTrainer} />

            <Route path="/thankyou" component={AnmeldungErfolgreich} />

            <Route path="/impressum-datenschutz" component={Impressum} />
            
            <Route component={Welcome} />
          </Switch>

        </div>

        <img className="bg" src={CoverImage} alt="Hintergrundbild - Single Trail"/>
      </div>
    )
  }
}

export default withRouter(App);



// WEBPACK FOOTER //
// ./src/App.js